export class SpaceTotals {
  notes: number;
  milestoneEvents: number;
  hasThesis: boolean;
  drafts: number;
  draftsUserNames: Array<string>;
  isEmpty: boolean;

  constructor (total: any = {}) {
    this.notes = total.notes || 0;
    this.milestoneEvents = total.milestoneEvents || 0;
    this.hasThesis = total.hasThesis || false;
    this.drafts = total.drafts || 0;
    this.draftsUserNames = total.draftsUserNames || [];
    this.isEmpty = total.isEmpty || true;
  }
}
